<template>
  <div>
    <div class="hero-banner-five">
      <div class="container">
        <div class="row">
          <div class="col-xl-10 col-lg-11 col-md-10 m-auto">
            <h1 class="hero-heading">
              {{ $t('intro.secondLineText') }}<span class="highlight"> {{ $t('intro.secondHighlight') }}</span>
            </h1>
            <h2 class="mt-15 second-highlight-container">
              <span class="second-highlight">{{ $t('intro.secondHighlight2') }}</span>
            </h2>
            <p class="hero-sub-heading">
              {{ $t('intro.subHeading') }}
            </p>
            <h3
                class="highlight-link mt-15"
            >
              <span>{{ $t('intro.highlight-link') }}</span>
            </h3>
          </div>
          <div class="block-style-sixteen-new">
            <img
                src="../../assets/images/assets/ai_app_dark_with_bedrock.svg"
                alt=""
                class="shapes screen-one"
                style="padding-left: 40px !important;"
            />
            <div class="mt-100 container">
              <div class="d-flex flex-row justify-content-around">
                <div class="intro-get-started-button">
                  <ul class="d-flex align-items-center justify-content-center">
                    <li>
                      <RequestButton
                          :is-making-request="creatingSession"
                          custom-class="request-button-default plausible-event-name=BuyClick"
                          :button-label="$t('intro.getStarted')"
                          @click="createCheckoutSession"
                      />
                    </li>
                  </ul>
                </div>
                <div class="intro-get-started-button">
                  <ul class="d-flex align-items-center justify-content-center">
                    <li>
                      <LinkToExternal
                          href="https://demo.saasconstruct.com"
                          custom-class="link-to-default plausible-event-name=DemoClick"
                          :link-label="$t('intro.seeDemo')"/>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="mt-45">
                <a class="plausible-event-name=productHunt"
                   href="https://www.producthunt.com/posts/saasconstruct?embed=true&utm_source=badge-featured&utm_medium=badge&utm_souce=badge-saasconstruct"
                   target="_blank"><img
                    src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=596920&theme=light"
                    alt="SaaSConstruct - SaaS&#0032;cloud&#0032;template&#0032;for&#0032;AWS&#0032;cloud | Product Hunt"
                    style="width: 250px; height: 54px;" width="250" height="54"/></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> <!-- /.partner-slider-two -->
  </div>
</template>


<script>

import {useAuthStore} from "@/store/auth";
import {isLemonSqueezy, isStripe} from "@/composables/useEnvironment";
import usePricingProducts from "@/composables/usePricingProducts";
import useCreateCheckoutSessionForOneTimePaymentsStripe
  from "@/composables/useCreateCheckoutSessionForOneTimePaymentsStripe";
import RequestButton from "@/components/buttons/RequestButton.vue";
import LinkToExternal from "@/components/buttons/LinkToExternal.vue";
import {ref} from "vue";
import useCreateCheckoutSessionForOneTimePaymentsLemonSqueezy
  from "@/composables/useCreateCheckoutSessionForOneTimePaymentsLemonSqueezy";


export default {
  name: 'SaasInfraIntro',
  components: {
    RequestButton,
    LinkToExternal
  },
  setup() {
    const creatingSession = ref(false)

    const {getMostPopularProduct} = usePricingProducts();
    const store = useAuthStore()

    let createCheckoutSessionForOneTimePayment;
    let createCheckoutSessionForOneTimePaymentWithoutLogin;

    if (isStripe()) {
      const {
        createCheckoutSessionForOneTimePaymentStripe,
        createCheckoutSessionForOneTimePaymentWithoutLoginStripe,
      } = useCreateCheckoutSessionForOneTimePaymentsStripe();

      createCheckoutSessionForOneTimePayment = createCheckoutSessionForOneTimePaymentStripe;
      createCheckoutSessionForOneTimePaymentWithoutLogin = createCheckoutSessionForOneTimePaymentWithoutLoginStripe;
    }

    if (isLemonSqueezy()) {
      const {
        createCheckoutSessionForOneTimePaymentLemonSqueezy,
        createCheckoutSessionForOneTimePaymentWithoutLoginLemonSqueezy,
      } = useCreateCheckoutSessionForOneTimePaymentsLemonSqueezy();

      createCheckoutSessionForOneTimePayment = createCheckoutSessionForOneTimePaymentLemonSqueezy;
      createCheckoutSessionForOneTimePaymentWithoutLogin = createCheckoutSessionForOneTimePaymentWithoutLoginLemonSqueezy;
    }

    const createCheckoutSession = async () => {
      const item = getMostPopularProduct()
      if (store.isAuthenticated) {
        await createCheckoutSessionForOneTimePayment(item, creatingSession);
      } else {
        await createCheckoutSessionForOneTimePaymentWithoutLogin(item, creatingSession);
      }
    }

    return {
      store,
      createCheckoutSession,
      creatingSession,
    };
  },
}
</script>

<style scoped>

.hero-banner-five .highlight-link {
  text-decoration: underline;
  text-decoration-color: #7736DC;
  text-decoration-thickness: 3px;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  font-family: "Roboto", sans-serif !important;
  font-size: 20px;
  padding: 20px 0 15px;
  color: #000;
}

.hero-heading {
  transition: opacity 0.5s;
  opacity: 1;
}

.hero-heading.hide {
  opacity: 0;
}

.second-highlight-container {
  text-align: center;
  font-weight: bold;
}

.hero-sub-heading {
  margin-top: 20px !important;
  padding-top: 5px !important;
}

.second-highlight {
  font-size: 2rem; /* Increase for visibility */
  font-weight: 600;
  color: #7736DC; /* Match Launch color */
  background: linear-gradient(90deg, #7736DC 30%, #AF6EE8 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: 0.5px;
  padding: 5px 10px;
  display: inline-block;
  transition: all 0.3s ease-in-out;
}

/* Subtle hover effect */
.second-highlight:hover {
  transform: scale(1.05);
}

@media (max-width: 991px) {
  .second-highlight {
    font-size: 28px;
  }

  .hero-sub-heading {
    padding-top: 0px !important;
    margin-top: 15px !important;
  }

  h2 {
    margin-top: 0px;
  }
}


</style>
